import useOverlayBadge from "@insite/client-framework/Common/Hooks/useOverlayBadge";
import useWidgetBadges from "@insite/client-framework/Common/Hooks/useWidgetBadges";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import updateProductInfo from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/UpdateProductInfo";
import { getProductInfoFromList } from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import ProductAddToListLink, {
    ProductAddToListLinkStyles,
} from "@insite/content-library/Components/ProductAddToListLink";
import { ProductAvailabilityStyles } from "@insite/content-library/Components/ProductAvailability";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import ProductContextAvailability from "@insite/content-library/Components/ProductContextAvailability";
import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import ProductImage, { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
import ProductImageBadges from "@insite/content-library/Components/ProductImageBadges";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import ProductQuantityBreakPricing, {
    ProductQuantityBreakPricingStyles,
} from "@insite/content-library/Components/ProductQuantityBreakPricing";
import ProductQuantityOrdered from "@insite/content-library/Components/ProductQuantityOrdered";
import ProductTextBadges from "@insite/content-library/Components/ProductTextBadges";
import ProductUnitOfMeasureSelect from "@insite/content-library/Components/ProductUnitOfMeasureSelect";
import Badge from "@insite/mobius/Badge";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { SelectPresentationProps } from "@insite/mobius/Select";
import { TextFieldProps } from "@insite/mobius/TextField";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { addToCartButtonGridStyle, qtyGridStyle } from "@tCooneyBrothers/Common/Utilities/productTileComponentStyle";
import Prop65Component from "@tCooneyBrothers/Components/Prop65Component";
import ProductAddToCartButton from "@tCooneyBrothers/Overrides/Components/ProductAddToCartButton";
import React, { useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => ({
    productInfo: getProductInfoFromList(state, ownProps.carouselId, ownProps.product.id),
    productSettings: getSettingsCollection(state).productSettings,
});

const mapDispatchToProps = {
    updateProductInfo,
};

interface OwnProps {
    carouselId: string;
    product: ProductModel;
    extendedStyles?: ProductCarouselProductFullStyles;
    actionsTemplate?: (product: ProductModel) => React.ReactNode;
    showImageBadges?: boolean;
    maximumNumberOfImageBadges?: number;
    showTextBadges?: boolean;
    maximumNumberOfTextBadges?: number;
}

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

export interface ProductCarouselProductFullStyles {
    container?: GridContainerProps;
    imageGridContainer?: GridContainerProps;
    productDescriptionContainer?: GridContainerProps;
    imageGridItem?: GridItemProps;
    productImageStyles?: ProductImageStyles;
    brandGridItem?: GridItemProps;
    productBrandWrapper?: InjectableCss;
    productBrandStyles?: ProductBrandStyles;
    descriptionGridItem?: GridItemProps;
    productDescriptionStyles?: ProductDescriptionStyles;
    partNumberGridItem?: GridItemProps;
    productPartNumbersStyles?: ProductPartNumbersStyles;
    productInfoStyleGridContainer?: GridContainerProps;
    availabilityGridItem?: GridItemProps;
    prop65GridItem?: GridItemProps;
    productAvailabilityStyles?: ProductAvailabilityStyles;
    priceGridItem?: GridItemProps;
    priceAndAddtoListWrapper?: InjectableCss;
    productPriceStyles?: ProductPriceStyles;
    unitOfMeasuresGridItem?: GridItemProps;
    productUnitOfMeasureSelectStyles?: SelectPresentationProps;
    quantityBreakPricingGridItem?: GridItemProps;
    productQuantityBreakPricingStyles?: ProductQuantityBreakPricingStyles;
    quantityOrderedGridItem?: GridItemProps;
    addToCartWrapper?: InjectableCss;
    productQuantityOrderedStyles?: TextFieldProps;
    productStandardActionsContainer?: GridContainerProps;
    addToCartGridItem?: GridItemProps;
    productAddToCartButtonStyles?: ButtonPresentationProps;
    addToListGridItem?: GridItemProps;
    productAddToListLinkStyles?: ProductAddToListLinkStyles;
    quantityOrdered?: TextFieldProps;
    addToCartButton?: ButtonPresentationProps;
    imageBadgeGridItem?: GridItemProps;
    textBadgeGridItem?: GridItemProps;
    badgeAreaWrapper?: InjectableCss;
    badgeTextWrapper?: InjectableCss;
    badgeImageWrapper?: InjectableCss;
    badgeText?: TypographyPresentationProps;
    badgeImageProps?: JSX.IntrinsicElements["img"];
}

export const productCarouselProductFullStyles: ProductCarouselProductFullStyles = {
    container: {
        gap: 8,
        css: css`
            height: 100%;
            > div {
                height: 100%;
                // display: block !important;
                // display: flex;
                align-items: flex-start;
                // display: block;
                width: 100% !important;
                margin: 0;
            }
            // border: 1px solid red;
            // width: 100%;

            // min-height: 100%;
        `,
    },
    imageGridContainer: {
        css: css`
            div[class^="GridOffset"] {
                width: 100%;
                margin: 0;
            }
        `,
    },
    productInfoStyleGridContainer: {
        gap: 7,
        css: css`
            justify-content: flex-end;
            margin-top: auto;
            width: 100%;
            div[class^="GridOffset"] {
                width: 100%;
                margin: 0;
            }
        `,
    },
    productDescriptionContainer: {
        // width: 12,
        gap: 8,
        css: css`
            width: 100%;
            margin: 0;
            align-items: flex-start;
            //  height: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            padding-bottom: 0 !important;
                        `,
                        null,
                    ],
                    "max",
                )}
            > div {
                background-color: #fafafa;
                height: 100%;
                // display: block !important;
                width: 100%;
                margin: 0;
                height: 100%;
                // display: flex;
                width: 100% !important;
            }
        `,
    },
    imageGridItem: {
        width: 12,
        css: css`
            justify-content: center;
            padding: 0 0 5px 0;
            a[data-test-selector="productImage"] {
                width: 100%;
                height: 100%;
                > div[class^="LazyImageStyle"] {
                    width: 100%;
                }
            }
        `,
    },
    productImageStyles: {
        linkWrappingImage: {
            css: css`
                justify-content: center;
                background-color: #fff;
                padding: 0 15px;
                [class^="StyledButton"] {
                    margin: 0 50px 15px;
                }
            `,
        },
    },
    brandGridItem: {
        width: 12,
        css: css`
            padding: 5px 15px 5px 15px;
        `,
    },
    productBrandWrapper: {
        css: css`
            margin: 6px 0;
            min-height: 22px;
        `,
    },
    descriptionGridItem: {
        width: 12,
        css: css`
            padding: 15px;
        `,
    },
    productDescriptionStyles: {
        productDetailLink: {
            css: css`
                margin-bottom: 6px;
                padding: 5px 15px;
            `,
        },
    },
    partNumberGridItem: {
        css: css`
            padding: 5px 0 0;
        `,
    },
    productPartNumbersStyles: {
        container: {
            css: css`
                flex-grow: 0;
                margin-bottom: 6px;
            `,
        },
        erpNumberLabelText: { size: 13 },
        erpNumberValueText: { size: 13 },
    },
    prop65GridItem: {
        width: 12,
        css: css`
            display: flex;
            align-items: center;
            padding: 10px 10px;
        `,
    },
    availabilityGridItem: {
        width: 12,
        css: css`
            padding: 5px 15px;
            display: flex;
            align-items: center;
            height: 48px;
            padding: 10px 10px;
            [class^="GridOffset"] {
                margin-top: 0;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            div[data-test-selector^="availability_wrapper"] {
                                span[data-test-selector^="callForAvailability"] {
                                    font-size: 10px;
                                }
                            }
                        `,
                    ],
                    "max",
                )}
        `,
    },
    priceGridItem: {
        width: [12, 12, 12, 12, 8],
        css: css`
            padding-left: 15px;
        `,
    },
    priceAndAddtoListWrapper: {
        css: css`
            width: 100%;
            display: flex;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            display: block;
                        `,
                        css`
                            display: block;
                        `,
                        css`
                            display: block;
                        `,
                        css`
                            display: block;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    unitOfMeasuresGridItem: {
        width: 12,
    },
    productUnitOfMeasureSelectStyles: {
        labelProps: {
            css: css`
                flex: 1;
            `,
        },
        cssOverrides: {
            formInputWrapper: css`
                flex: 1;
            `,
        },
    },
    quantityBreakPricingGridItem: {
        width: 12,
    },
    addToCartWrapper: {
        css: css`
            display: flex;
            align-items: flex-end;
            margin-top: 10px;
            padding: 0px 0;
            width: 100%;
            // margin-bottom: -21px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            position: static !important;
                        `,
                        css`
                            position: absolute;
                            left: 0;
                            bottom: 0;
                            > div[class^="FormFieldStyle"] > label {
                                font-size: 10px;
                                padding: 3px;
                            }
                        `,
                        css`
                            position: absolute;
                            left: 0;
                            bottom: 0;
                            > div[class^="FormFieldStyle"] > label {
                                font-size: 10px;
                                padding: 3px;
                            }
                        `,
                    ],
                    "max",
                )}
            > button > span {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                font-size: 10px;
                                // padding: 3px;
                            `,
                        ],
                        "max",
                    )}
            }
        `,
    },
    quantityOrdered: {
        cssOverrides: {
            formField: qtyGridStyle,
        },
    },
    addToCartButton: { css: addToCartButtonGridStyle },
    quantityOrderedGridItem: {
        width: 6,
    },
    productQuantityOrderedStyles: {
        labelProps: {
            css: css`
                flex: 1;
            `,
        },
        labelPosition: "left",
        cssOverrides: {
            formInputWrapper: css`
                flex: 1;
            `,
        },
    },
    productStandardActionsContainer: {
        gap: 6,
        css: css`
            // padding-top: 12px;
            border: 1px solid;
        `,
    },
    addToCartGridItem: {
        width: 6,
    },
    productAddToCartButtonStyles: {
        css: css`
            width: 100%;
        `,
    },
    addToListGridItem: {
        width: [12, 12, 12, 12, 4],
        css: css`
            justify-content: flex-end;
            span {
                text-transform: uppercase;
                font-size: 11px;
                font-weight: 600;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            justify-content: flex-start;
                            padding-left: 15px;
                            padding-bottom: 15px;
                            margin-bottom: 10px !important;
                        `,
                        css`
                            justify-content: flex-start;
                            padding-left: 15px;
                            padding-bottom: 15px;
                            margin-bottom: 10px !important;
                        `,
                    ],
                    "max",
                )}
            padding-right: 15px;
        `,
    },
    productAddToListLinkStyles: {
        link: {
            typographyProps: { size: 13 },
            css: css`
                margin-bottom: 12px;
            `,
        },
    },
    imageBadgeGridItem: {
        width: 12,
    },
    textBadgeGridItem: {
        width: 12,
    },
    badgeAreaWrapper: {
        css: css`
            position: relative;
        `,
    },
    badgeTextWrapper: {
        css: css`
            position: absolute;
            width: 50%;
            white-space: nowrap;
            overflow: hidden;
        `,
    },
    badgeImageWrapper: {
        css: css`
            position: absolute;
            width: 25%;
            height: 25%;
        `,
    },
    badgeText: {
        weight: "bold",
        css: css`
            width: 100%;
            margin: auto;
            ${wrapInContainerStyles}
        `,
    },
};

const ProductCarouselProductFull = ({
    carouselId,
    product,
    extendedStyles,
    productInfo,
    productSettings,
    updateProductInfo,
    actionsTemplate,
    showImageBadges,
    maximumNumberOfImageBadges,
    showTextBadges,
    maximumNumberOfTextBadges,
}: Props) => {
    const [styles] = useState(() => mergeToNew(productCarouselProductFullStyles, extendedStyles));

    const updateQuantity = (qtyOrdered: number) => {
        updateProductInfo({ id: carouselId, productId: product.id, qtyOrdered });
    };

    const updateUnitOfMeasure = (unitOfMeasure: string) => {
        updateProductInfo({ id: carouselId, productId: product.id, unitOfMeasure });
    };

    if (!product || !productInfo) {
        return null;
    }

    const productContext = {
        product,
        productInfo,
        onUnitOfMeasureChanged: updateUnitOfMeasure,
        onQtyOrderedChanged: updateQuantity,
    };
    const {
        showOverlayBadge,
        overlayBadge,
        overlayBadgeWrapperStyles,
        badgeAreaWrapperRef,
        overlayBadgeWrapperClickHandler,
    } = useOverlayBadge({
        productContext,
        showTextBadge: showTextBadges,
        showImageBadge: showImageBadges,
        styles,
    });

    const { imageBadges, textBadges } = useWidgetBadges({ productContext, showTextBadges, showImageBadges });

    return (
        <>
            <ProductContext.Provider value={productContext}>
                <GridContainer
                    id={`productContainer_${product.id}`}
                    {...styles.container}
                    data-test-selector="productContainer"
                >
                    {/* <GridContainer {...styles.imageGridContainer}> */}

                    {/* </GridContainer> */}
                    <GridContainer {...styles.imageGridContainer}>
                        {/* {product.brand && (
                            <GridItem {...styles.brandGridItem}>
                                <StyledWrapper {...styles.productBrandWrapper}>
                                    <ProductBrand brand={product.brand} extendedStyles={styles.productBrandStyles} />
                                </StyledWrapper>
                            </GridItem>
                        )} */}
                        <GridItem {...styles.imageGridItem}>
                            {!showOverlayBadge && (
                                <ProductImage extendedStyles={styles.productImageStyles} product={productContext} />
                            )}
                            {showOverlayBadge && overlayBadge && (
                                <StyledWrapper
                                    {...styles.badgeAreaWrapper}
                                    ref={badgeAreaWrapperRef}
                                    data-test-selector="productCompareBadge"
                                >
                                    <ProductImage extendedStyles={styles.productImageStyles} product={productContext} />
                                    <StyledWrapper {...overlayBadgeWrapperStyles} onClick={overlayBadgeWrapperClickHandler}>
                                        <Badge
                                            type={overlayBadge.badgeType}
                                            value={
                                                overlayBadge.badgeType === "Image"
                                                    ? overlayBadge.largeImageBadgePath
                                                    : overlayBadge.displayText
                                            }
                                            badgeTextColor={overlayBadge.textColorHexCode}
                                            badgeBackgroundColor={overlayBadge.badgeColorHexCode}
                                            badgeTextRounding={overlayBadge.badgeStyle === "Round" ? 20 : 0}
                                            imageAltText={
                                                overlayBadge.imageAltText
                                                    ? overlayBadge.imageAltText
                                                    : overlayBadge.name
                                            }
                                            textBadgeCss={styles.badgeText}
                                            imageBadgeProps={styles.badgeImageProps}
                                        />
                                    </StyledWrapper>
                                </StyledWrapper>
                            )}
                        </GridItem>
                        <GridItem {...styles.descriptionGridItem}>
                            <ProductDescription
                                product={productContext}
                                extendedStyles={styles.productDescriptionStyles}
                            />
                        </GridItem>
                    </GridContainer>
                    <GridContainer {...styles.productInfoStyleGridContainer}>
                        <GridItem {...styles.partNumberGridItem}>
                            <ProductPartNumbers
                                productNumber={product.productNumber}
                                customerProductNumber={product.customerProductNumber}
                                manufacturerItem={product.manufacturerItem}
                                showCustomerName={true}
                                showManufacturerItem={true}
                                showLabel={true}
                                extendedStyles={styles.productPartNumbersStyles}
                            />
                        </GridItem>
                        {showTextBadges && textBadges && (
                            <GridItem {...styles.textBadgeGridItem}>
                                <ProductTextBadges badgeList={textBadges} maxBadges={maximumNumberOfTextBadges ?? 4} />{" "}
                            </GridItem>
                        )}
                        {showImageBadges && imageBadges && (
                            <GridItem {...styles.imageBadgeGridItem}>
                                <ProductImageBadges
                                    badgeList={imageBadges}
                                    maxBadges={maximumNumberOfImageBadges ?? 4}
                                />
                            </GridItem>
                        )}
                        <GridItem {...styles.availabilityGridItem}>
                            <ProductContextAvailability extendedStyles={styles.productAvailabilityStyles} />
                        </GridItem>

                        {product?.properties?.prop65 && (
                            <GridItem {...styles.prop65GridItem}>
                                <Prop65Component messageToDisplay={product.properties.prop65}></Prop65Component>
                            </GridItem>
                        )}

                        <StyledWrapper {...styles.priceAndAddtoListWrapper}>
                            <GridItem {...styles.priceGridItem}>
                                <ProductPrice
                                    showLabel={false}
                                    showSavings={true}
                                    showSavingsAmount={productSettings.showSavingsAmount}
                                    showSavingsPercent={productSettings.showSavingsPercent}
                                    product={productContext}
                                    extendedStyles={styles.productPriceStyles}
                                />
                            </GridItem>
                            <GridItem {...styles.addToListGridItem}>
                                <ProductAddToListLink
                                    data-test-selector="addToListLink"
                                    extendedStyles={styles.productAddToListLinkStyles}
                                />
                            </GridItem>
                        </StyledWrapper>
                        <GridItem {...styles.unitOfMeasuresGridItem}>
                            {product.unitOfMeasures && (
                                <ProductUnitOfMeasureSelect
                                    labelPosition="left"
                                    extendedStyles={styles.productUnitOfMeasureSelectStyles}
                                />
                            )}
                        </GridItem>
                        <GridItem {...styles.quantityBreakPricingGridItem}>
                            <ProductQuantityBreakPricing extendedStyles={styles.productQuantityBreakPricingStyles} />
                        </GridItem>
                        {/* <GridItem {...styles.quantityOrderedGridItem}>
                        <ProductQuantityOrdered extendedStyles={styles.productQuantityOrderedStyles} />
                        </GridItem> */}
                        {/* </GridContainer> */}
                        {/* </GridContainer> */}
                        {/* <GridContainer {...styles.productStandardActionsContainer}> */}
                        {/* <GridItem {...styles.quantityOrderedGridItem}> */}
                        <StyledWrapper {...styles.addToCartWrapper}>
                            <ProductQuantityOrdered extendedStyles={styles.quantityOrdered} />
                            {/* </GridItem> */}
                            {/* <GridItem {...styles.addToCartGridItem}> */}
                            <ProductAddToCartButton
                                data-test-selector="addToCartBtn"
                                extendedStyles={styles.addToCartButton}
                            />
                        </StyledWrapper>
                        {/* </GridItem> */}
                        {/* </GridContainer> */}
                        {/* <GridItem {...styles.addToListGridItem}>
                        <ProductAddToListLink
                            data-test-selector="addToListLink"
                            extendedStyles={styles.productAddToListLinkStyles}
                        />
                       </GridItem> */}
                    </GridContainer>
                </GridContainer>
                {actionsTemplate ? actionsTemplate(product) : []}
            </ProductContext.Provider>
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductCarouselProductFull);
